import { supabase } from '@/src/core/config/supabase';
import { logger } from '@/src/core/utils';

export type FeedbackType = 'bug' | 'feature' | 'general';

export class SubmitFeedbackUseCase {
  async execute(params: {
    userId: string;
    userEmail: string;
    type: FeedbackType;
    message: string;
    appVersion?: string;
  }): Promise<void> {
    const { userId, userEmail, type, message, appVersion } = params;

    if (!message.trim()) {
      throw new Error('Message is required');
    }

    logger.debug('SubmitFeedback', 'Submitting feedback', { type });

    const { error } = await supabase.from('feedback').insert({
      user_id: userId,
      user_email: userEmail,
      type,
      message: message.trim(),
      app_version: appVersion ?? null,
    });

    if (error) {
      logger.error('SubmitFeedback', 'Failed to submit feedback', { error });
      throw new Error(error.message);
    }

    logger.info('SubmitFeedback', 'Feedback submitted', { type });
  }
}
